import React, { createContext, useContext, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const TeleconsultContext = createContext();

export function useTeleconsultContext() {
  return useContext(TeleconsultContext);
}

export function TeleconsultProvider(props) {
  const [showHotlines, setShowHotlines] = useState({});
  const navigate = useNavigate();

  const handleBackToDashboard = () => {
    navigate("/home");
  };

  const data = useMemo(
    () => ({
      handleBackToDashboard,
      setShowHotlines,
      navigate,

      showHotlines,
    }),
    [showHotlines]
  );

  return (
    <TeleconsultContext.Provider value={data}>
      {props.children}
    </TeleconsultContext.Provider>
  );
}

TeleconsultProvider.propTypes = {
  children: PropTypes.any,
};
